import { ReactNode } from 'react';

import { Card } from '@ui/components/Card';

import styles from '@features/user/ui/SomePlayerStats/SomePlayerStats.module.css';

type Props = {
  children: ReactNode;
};
export function SomePlayerStats({ children }: Props) {
  return (
    <Card className={styles.somePlayerEloStatsPreview}>
      <div className={styles.header}>
        <div className={styles.title}>Рейтинг и партии</div>

        {/*<SlimArrowButton
          colorPreset="golden"
          direction="right"
          size="20"
          onClick={() => setIsModalOpen(true)}
        />*/}
      </div>

      <div className={styles.content}>{children}</div>

      {/*
      <CapsuleButton
        className={styles.button}
        preset="hollow-golden"
        size="16r-32"
        onClick={() => setIsModalOpen(true)}
      >
        <span>История партий</span>
        <span className={styles.arrow}>
          <ArrowSlimIcon />
        </span>
      </CapsuleButton>
      */}
    </Card>
  );
}
